module.exports = __webpack_public_path__ + "static/img/2.348a16a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/2.jpg
// module id = 88
// module chunks = 2